import { Theme } from "@emotion/react";
import { Avatar, SxProps } from "@mui/material";
import React from "react";

interface ImageLogoProps {
    src?: string;
    size?: number;
    alt?: string;
    sx?: SxProps<Theme>;
}

const ImageLogoComponent = (props: ImageLogoProps) => {
    return (
        <Avatar
            src={props.src}
            alt={props.alt}
            sx={props.sx}
        />
    );
};

export default ImageLogoComponent;